import React, { useState, useEffect } from "react";
import { TextField } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import Alert from "@material-ui/lab/Alert";
import { fullCheck } from "../utils/CSVInjectedUtil";
function KpsTextField(props) {
  // const [characters, setCharacters] = useState([
  //   "=",
  //   "+",
  //   "-",
  //   "@",
  //   "\t",
  //   "\r",
  // ]);
  // const [seperators, setSeperators] = useState([",", ";", "'", '"']);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {}, []);
  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };
  const onChange = (e) => {
    setAnchorEl(e.currentTarget);
    let isASecurityRisk = fullCheck(e.target.value);
    if (!isASecurityRisk) {
      props.onChange(e);
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      {" "}
      <TextField
        {...props}
        onChange={onChange}
        value={props.value ? props.value : ""}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Alert severity="warning" elevation={3}>
          You have been stopped from inputing this combination of charactes due
          to potential security risks.
        </Alert>
      </Popover>
    </>
  );
}

export default KpsTextField;
